import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconUploadLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.308 19.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283v-1.961a.73.73 0 0 1 .215-.535.725.725 0 0 1 .535-.215.73.73 0 0 1 .535.215.725.725 0 0 1 .215.535v1.961c0 .077.032.148.096.212a.293.293 0 0 0 .212.096h11.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212v-1.961a.73.73 0 0 1 .215-.535.725.725 0 0 1 .535-.215.73.73 0 0 1 .535.215.725.725 0 0 1 .215.535v1.961c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H6.308ZM11.25 7.388 9.327 9.311a.715.715 0 0 1-.53.22.751.751 0 0 1-.54-.235.783.783 0 0 1-.224-.527.7.7 0 0 1 .225-.527l3.11-3.11A.828.828 0 0 1 12 4.878a.828.828 0 0 1 .633.256l3.11 3.11a.706.706 0 0 1 .22.521.769.769 0 0 1-.22.532.765.765 0 0 1-.535.24.708.708 0 0 1-.535-.225L12.75 7.388v7.65a.725.725 0 0 1-.216.535.726.726 0 0 1-.534.216.726.726 0 0 1-.534-.216.725.725 0 0 1-.216-.534v-7.65Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconUploadLine;
